export default "__VITE_ASSET__2e369dc3__"